import React, { Component } from 'react';
import { List, OrderedMap } from 'immutable';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import EditableTextField from './EditableTextField';
import css from './forms.css';

// Material UI Library
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FlatButton from 'material-ui/FlatButton'

class MultiTextEdit extends Component {

  constructor(props) {
    super(props);
    this.state = { items: this.props.collection.toOrderedMap() };
  }

  componentWillReceiveProps(newProps) {
    if (!isEqual(newProps.collection.toJS(), this.props.collection.toJS())) {
      this.setState({ items: newProps.collection.toOrderedMap() });
    }
  }

  handleUpdateForm = (key, id, value) => {
    const updatedProperty = id ? { id: id, [this.props.name]: value } : { [this.props.name]: value };
    const items = this.state.items.mergeIn([key], updatedProperty);

    this.props.saveValue(items.toList().toJS());
  };

  addAnotherItem = () => {
    this.setState({ items: this.state.items.merge({
      [this.state.items.size]: {
        [this.props.name]: '',
      },
    }),
    });
  };

  removeItem = (key) => {
    // Update db if existing item
    if (this.state.items.get(key).get('id')) {
      this.props.saveValue([{ id: this.state.items.get(key).get('id'), _destroy: true }]);
    } else {
      const updatedItems = this.state.items.delete(key);
      this.setState({ items: updatedItems });
    }
  };

  render() {
    // Allow adding new collection items
    if (this.state.items.size <= 0) {
      return (
        <FlatButton
          onClick={this.addAnotherItem}
          icon={<ContentAdd />}
        >
          Add {this.props.floatingLabelText}
        </FlatButton>
      )
    }

    return (
      <div>
        {this.state.items.mapEntries(([key, value]) =>
          [
            key,
            <section>
              <EditableTextField
                key={`${this.props.name}-${key}`}
                name={this.props.name}
                floatingLabelText={this.props.floatingLabelText}
                type="text"
                fullWidth={true}
                value={value.get(this.props.name)}
                saveValue={this.handleUpdateForm.bind(this, key, value.get('id'))}
                style={{ flexGrow: 1 }}
              />
              <IconButton
                key={`${this.props.name}-contentadd-${key}`}
                onTouchTap={this.addAnotherItem}
              >
                <ContentAdd />
              </IconButton>
              <IconButton
                key={`${this.props.name}-navclose-${key}`}
                onTouchTap={this.removeItem.bind(this, key)}
              >
                <NavigationClose />
              </IconButton>
            </section>,
          ]
        ).toList()}
      </div>
    );
  }
}

export default MultiTextEdit;



/** WEBPACK FOOTER **
 ** ./components/forms/MultiTextEdit.js
 **/